import { useParams } from "react-router-dom";
import { nameOf } from "../../Utils/nameOf";
import Odc from "../Odc";
import OdcFormTabs from "./OdcFormTabs";
import { useUpdateOdc } from "../Hooks/useUpdateOdc";
import { useFetchOdc } from "../Hooks/useFetchOdc";
import { useDeleteOdc } from "../Hooks/useDeleteOdc";

export const EditOdc = () => {
  const { odcId } = useParams();
  const { data: odc } = useFetchOdc(odcId);
  const { mutate: updateOdc } = useUpdateOdc(odcId);
  const { mutate: deleteOdc } = useDeleteOdc(odcId);

  const disabledFields: Array<string> = [
    nameOf<Odc>("Gsdb"),
    nameOf<Odc>("Type"),
    nameOf<Odc>("MgLatitude"),
    nameOf<Odc>("MgLongitude"),
  ];

  return (
    <OdcFormTabs
      title="Edit ODC"
      odc={odc}
      onSave={(it: Odc) => updateOdc(it)}
      onDelete={(it: Odc) => deleteOdc(it)}
      disabledFields={disabledFields}
    />
  );
};
